<template src='./template.html'></template>

<script>
export default {
  name: "AdTypeCreate",
  data() {
    return {
      dialog: false,
      valid: false,
      editedItem: {
        Name: "",
        ProjectTypeID: "",
        Status: "Y",
        NewTime: "2021-04-23",
      },
      defaultItem: {
        Name: "",
        ProjectTypeID: "",
        Status: "Y",
        NewTime: "2021-04-23",
      },
      type_array: [
        {
          label: "已啟用",
          value: "Y"
        },
        {
          label: "已停用",
          value: "N"
        }
      ],
      rules: {
        required: value => { return (value == '') ? '此欄位不得留空' : true },
      },
    }
  },
  methods: {
    Open() {
      this.dialog = true
      this.valid = true
      this.$emit("load-data")
    },
    Close() {
      this.editedItem = Object.assign({}, this.defaultItem)
      this.dialog = false
      this.valid = true
    },
    Validate() {
      this.$refs.CustomerForm.validate()
      setTimeout(() => {
        this.valid ? this.CreateCustomer() : ""
      }, 100);
    },
    async CreateCustomer() {
      this.$store.commit("SetLoading", true)
      let response = await this.SendData("/admin/project/type", "post", { Data: this.editedItem })
      this.$store.commit("SetLoading", false)
      if (response != "error") {
        this.Close()
        this.$emit("load-data")
        this.$store.commit("SetSnackBar", { status: true, content: "已成功新增廣告類型" })
      }
    }
  },
}
</script>